import { Slide } from '../state/editorTypes';

const scaleDashboardPages = (scaleFactor: number, pages: Slide[]) => {
  return (
    pages.map(p => {
      return {
        ...p,
        tplHeight: p.tplHeight || 540,
        tplWidth: p.tplWidth || 960,
        width: p.width * scaleFactor,
        height: p.height * scaleFactor,
        elements: p.elements.map(el => {
          let { tag } = el;
          if (tag.indexOf('#') < 0) {
            tag = `${p.slideNumber}#${tag}`;
          }
          return {
            ...el,
            x: el.x * scaleFactor,
            y: el.y * scaleFactor,
            width: el.width * scaleFactor,
            height: el.height * scaleFactor,
            tag
          };
        })
      };
    }) || []
  );
};

export default scaleDashboardPages;
